import * as yup from 'yup'

import constants from 'constants/index'

export const EDITOR_FIELDS = ['title', 'content', 'attachment']

const editorSchema = yup.object({
  title: yup.string().max(255).required(),
  content: yup.string().when('contentKind', {
    is: constants.documents.WRITTEN_CONTENT_KIND,
    then: (schemaOption) => schemaOption.richTextRequired(),
  }),
  attachment: yup.mixed().fileUpload({
    fileGroup: 'document',
    sizeMessage: 'O documento deve ter no máximo 10 MB',
    required: {
      field: 'contentKind',
      is: constants.documents.ATTACHMENT_CONTENT_KIND,
    },
  }),
})

export default editorSchema
